export default __webpack_public_path__ + "487c8b6e1422c612b9eb6039b8cfc80a.png";